import "Layouts/default";

import 'Ui/tabs'

document.addEventListener('DOMContentLoaded', function() {
    const urlString = window.location.href.toLowerCase(),
        urlObject = new URL(urlString),
        tabId = urlObject.searchParams.get('id'),
        branchesContent = document.querySelector('.js-branches-content');

    if (tabId) {
        setTimeout(() => {
            document.querySelector('.js-branches-tabs').openTab(`contact-branch-${tabId}`);

            window.scrollTo({
                top: branchesContent.offsetTop,
                behavior: 'smooth'
            });
        }, 250);
    }
});